import CitySelect from "@/components/CitySelect/CitySelect";
import { FilterSection } from "@/components/filter/FilterSection";
import { useFilterHandlers } from "@/components/filter/useFilterHandlers";
import { CheckboxField } from "@/components/ui-components/CheckboxField";
import { DisabledMessage } from "@/components/ui-components/CheckboxField/CheckboxField";
import { getStoresByCity } from "@/helpers/getStoresByCity";
import useFilterQuery from "@/hooks/useFilterQuery";

import styles from "./FilterStores.module.scss";

const FilterStores = () => {
  const { stores, selectedStores } = useFilterQuery();
  const { selectSingleStore } = useFilterHandlers();
  const selectedCity = localStorage.getItem("city") || "Интернет-магазин";

  const storesInTheCity = getStoresByCity(stores, selectedCity);

  const isChecked = (storeId: string) => {
    return selectedStores.includes(storeId);
  };

  if (!stores?.length) return null;

  const disabledMessage: DisabledMessage = {
    title: "магазин недоступен",
    body: "измените критерии поиска",
  };

  return (
    <FilterSection
      title="Магазины"
      count={selectedStores.length}
      afterTitle={<CitySelect />}
      className={styles.section}
    >
      {storesInTheCity.map((store) => {
        const checked = isChecked(store.id);
        const toggleChecked = () => {
          selectSingleStore(store.id);
        };
        return (
          <CheckboxField
            label={removeCityFromName(store.name)}
            checked={checked}
            toggleChecked={toggleChecked}
            key={store.id}
            disabled={store.disabled}
            disabledMessage={disabledMessage}
          />
        );
      })}
    </FilterSection>
  );
};

const removeCityFromName = (storeName: string) => {
  const parts = storeName.split(", ");
  if (parts.length === 1) return storeName;
  return parts.slice(1).join(", ");
};

export default FilterStores;
